import { useCallback, useState } from "react";
import { CompanyResult, DashboardStoreInterface, DashboardStoreKey, DepartmentPlanResultInterface, LtwCompanyResultItem, MyPlanResultInterface, TopDepartmentResultInterface, TopEmployeesResult } from "../model/dashboard.types";
import { getFirstDayOfCurrentMonth, getLastDayOfCurrentMonth, toLocalDateString } from "@/shared/lib/dates";

const useDashboardStore = ():DashboardStoreInterface => {
  const [loading, updateLoadingState] = useState<Record<DashboardStoreKey, boolean>>({
    dashboardDepartmentPlanResult: false,
    dashboardCompanyPlanResult: false,
    dashboardUserPlanResult: false,
    dashboardTopDepartments: false,
    dashboardMyPlanResult: false,
    dashboardTopEmployees: false,
    dashboardLTWCompany: false,
  });
 
  const [error, updateErrorState] = useState<Record<DashboardStoreKey, string | null>>({
    dashboardDepartmentPlanResult: null,
    dashboardCompanyPlanResult: null,
    dashboardUserPlanResult: null,
    dashboardTopDepartments: null,
    dashboardTopEmployees: null,
    dashboardMyPlanResult: null,
    dashboardLTWCompany: null,
  });

  const setLoadingState = useCallback((key: DashboardStoreKey, value: boolean) => {
    updateLoadingState(prev => ({ ...prev, [key]: value }));
  }, []);

  const setErrorState = useCallback((key: DashboardStoreKey, value: string | null) => {
    updateErrorState(prev => ({ ...prev, [key]: value }));
  }, []);

  const [dateStart, setDateStart] = useState<string | null>(() => {
    const stored = localStorage.getItem("dateStart");
    if (stored) return stored;
    const first = getFirstDayOfCurrentMonth();
    const str = toLocalDateString(first);
    localStorage.setItem("dateStart", str);
    return str;
  });
  const [dateEnd, setDateEnd] = useState<string | null>(() => {
    const stored = localStorage.getItem("dateEnd");
    if (stored) return stored;
    const last = getLastDayOfCurrentMonth();
    const str = toLocalDateString(last);
    localStorage.setItem("dateEnd", str);
    return str;
  });
  const [selectedDepartment, setSelectedDepartment] = useState<string | null>(null);
  
  const [companyPlanResultProfit, setCompanyPlanResultProfit] = useState<CompanyResult | null>(null);
  const [companyPlanResultOpportunity, setCompanyPlanResultOpportunity] = useState<CompanyResult | null>(null);
  const [dashboardTopEmployeesCompany, setDashboardTopEmployeesCompany] = useState<TopEmployeesResult[]>([]);
  const [dashboardTopEmployeesDepartment, setDashboardTopEmployeesDepartment] = useState<TopEmployeesResult[]>([]);
  const [myPlanResult, setMyPlanResult] = useState<MyPlanResultInterface | null>(null);
  const [userPlanResult, setUserPlanResult] = useState<MyPlanResultInterface | null>(null);
  const [departmentPlanResult, setDepartmentPlanResult] = useState<DepartmentPlanResultInterface | null>(null);
  const [dashboardLTWCompany, setDashboardLTWCompany] = useState<LtwCompanyResultItem[]>([]);
  const [dashboardTopDepartments, setDashboardTopDepartments] = useState<TopDepartmentResultInterface[]>([]);

  
  
  return {
    loading, setLoadingState,
    error, setErrorState,

    dateStart, setDateStart,
    dateEnd, setDateEnd,
    selectedDepartment, setSelectedDepartment,

    companyPlanResultProfit, setCompanyPlanResultProfit,
    companyPlanResultOpportunity, setCompanyPlanResultOpportunity,

    dashboardTopEmployeesCompany, setDashboardTopEmployeesCompany,
    dashboardTopEmployeesDepartment, setDashboardTopEmployeesDepartment,
    
    myPlanResult, setMyPlanResult,
    userPlanResult, setUserPlanResult,
    departmentPlanResult, setDepartmentPlanResult,
    
    dashboardTopDepartments, setDashboardTopDepartments,
    dashboardLTWCompany, setDashboardLTWCompany
  }
}

export default useDashboardStore;
